<template>
  <div class="gold-sight">
    <div class="banner">
      <div class="banner-box">
        <div class="banner-text">
          <div class="slogan animate__animated animate__fadeInLeftBig">专为科技金融打造的智能决策引擎</div>

          <div class="title animate__animated animate__fadeInLeftBig">点睛投研</div>

          <div class="sub-title animate__animated animate__fadeInLeftBig">
            专为VC投资机构打造，面向海量科技企业，高效筛选优质投资标的，输出多维投资评级与量化分析报告，辅助<br />
            投资决策全流程。<br />
          </div>

          <div class="tags-container animate__animated animate__fadeInLeftBig">
            <span v-for="(tag, index) in tags" :key="index">{{ tag }}</span>
          </div>

          <div class="dimension-container animate__animated animate__fadeInLeftBig">
            <span class="dimension-title">多维数据支撑</span>
            <div class="dimension-content">
              <div class="dimension-item" v-for="(item, index) in dimensionList" :key="index">
                <i class="iconfont icon-gouxuan-mianxing"></i>
                <span>{{ item }}</span>
              </div>
            </div>
          </div>

          <div class="btn-container animate__animated animate__fadeInUp">
            <div class="exp-btn" @click="toRegister">
              <span>申请体验</span>
              <i class="iconfont icon-youjiantou-xianxing"></i>
            </div>
            <div class="jump-btn">
              <span>已有账号？</span>
              <span @click="toJump">直接使用</span>
            </div>
          </div>
        </div>

        <div class="banner-card animate__animated animate__fadeInRightBig">
          <div class="card-item" v-for="(item, index) in cardList" :key="index" :style="{ backgroundImage: `url(${item.bgUrl})` }">
            <div class="card-title">
              <img :src="item.iconUrl" alt="">
              <span>{{ item.title }}</span>
            </div>
            <div class="card-desc">{{ item.desc }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'

export default {
  name: 'OwnerView',
  computed: {
    ...mapState(['isLogin'])
  },
  data () {
    return {
      tags: ['标的筛选', '竞品分析', '投后管理'],
      dimensionList: ['国家知识产权局全量权威数据', '460万+科技企业基因库', '专利、融资、人才多维穿透'],
      cardList: [
        {
          title: '四维加权评分',
          desc: '从人才团队、产业前景、核心科技属性、经营可持续性四大维度综合评估企业投资价值，输出六档投资评级',
          iconUrl: 'https://images.zzt.com.cn/cdn_file/zst-official/icon_四维加权评分.png',
          bgUrl: 'https://images.zzt.com.cn/cdn_file/zst-official/bg_四维加权评分.png'
        },
        {
          title: '全景投资分析',
          desc: '穿透企业技术壁垒、产业链卡位、财务健康度与成长动能，提供从竞品对标到尽调要点的完整决策依据',
          iconUrl: 'https://images.zzt.com.cn/cdn_file/zst-official/icon_全景投资分析.png',
          bgUrl: 'https://images.zzt.com.cn/cdn_file/zst-official/bg_全景投资分析.png'
        },
        {
          title: '效率倍增',
          desc: '将初筛效率从每份2小时压缩至5分钟，覆盖项目初筛、竞品对比、立项评审、投后跟踪四大核心场景，让投资判断更高效、更精准',
          iconUrl: 'https://images.zzt.com.cn/cdn_file/zst-official/icon_效率倍增.png',
          bgUrl: 'https://images.zzt.com.cn/cdn_file/zst-official/bg_效率倍增.png'
        }
      ]
    }
  },
  methods: {
    toRegister () {
      this.$router.push('/register')
      window.scrollTo(0, 0, 'smooth')
    },
    toJump () {
      window.open(`${process.env.VUE_APP_GOLDSIGHTURL}home?token=${this.$store.state.token}`)
    }
  }
}
</script>
<style lang='scss' scoped>
.gold-sight {
  .banner {
    width: 100%;
    min-width: $container-width;
    height: Translate(690px);
    background: url("https://images.zzt.com.cn/cdn_file/zst-official/bg_点睛投研.png") no-repeat;
    background-position: center center;
    background-size: cover;
    margin: 0 auto;

    &-box {
      width: $container-width;
      margin: 0 auto;
      position: relative;
      height: 100%;
    }

    &-text {
      text-align: left;

      .slogan {
        position: absolute;
        top: Translate(58px);
        left: 0;
        @include Slogan();
      }

      .title {
        position: absolute;
        top: Translate(90px);
        left: 0;
        @include Text(60px, 500, 82px, #111, 'AlibabaPuHuiTiB');
      }

      .sub-title {
        width: Translate(680px);
        position: absolute;
        top: Translate(172px);
        left: 0;
        @include Text(14px, 400, 24px, #333333, 'PingFangSC-Regular');
      }

      .tags-container {
        position: absolute;
        top: Translate(234px);
        left: 0;
        display: flex;
        flex-wrap: wrap;
        gap: Translate(8px);

        span {
          @include Tag();
        }
      }

      .dimension-container {
        position: absolute;
        top: Translate(320px);
        left: 0;
        @include DimensionContainer();

        .dimension-title {
          @include Text(18px, 600, 25px, #111111, 'PingFangSC-Semibold');
        }

        .dimension-content {
          display: flex;
          flex-wrap: wrap;
          gap: Translate(8px) Translate(20px);
          margin-top: Translate(23px);

          .dimension-item {
            display: flex;
            align-items: center;
            gap: Translate(4px);

            i {
              font-size: Translate(14px);
              color: #91BAFF;
            }

            span {
              @include Text(14px, 400, 20px, #333333, 'PingFangSC-Regular');
            }
          }
        }
      }

      .btn-container {
        position: absolute;
        top: Translate(494px);
        left: 0;
        display: flex;
        flex-direction: column;
        gap: Translate(12px);

        .exp-btn {
          @include Button(180px, 60px, transparent, 16px, #fff);
          background-image: linear-gradient(90deg, #0058FF 0%, #12A4FA 100%);
          border-radius: Translate(30px);
          transition: all 0.15s ease-in;

          &:hover {
            opacity: 0.8;
            transform: translateY(Translate(-4px));
            box-shadow: 4px 10px 30px -4px rgba(0, 88, 255, 0.4);
          }

          i {
            font-size: Translate(22px);
            margin-left: Translate(6px);
            transition: transform 0.15s ease-in;
            @include ChevronIconAnimation();
          }
        }

        .jump-btn {
          width: Translate(180px);
          display: flex;
          justify-content: center;

          span:first-child {
            @include Text(14px, 400, 20px, #333333, 'PingFangSC-Regular');
          }

          span:last-child {
            cursor: pointer;
            @include Text(14px, 500, 20px, #0058FF, 'PingFangSC-Medium');

            &:hover {
              opacity: 0.8;
            }
          }
        }
      }
    }

    &-card {
      position: absolute;
      top: Translate(58px);
      right: 0;
      text-align: left;
      display: flex;
      flex-direction: column;
      gap: Translate(18px);

      .card-item {
        width: Translate(340px);
        height: Translate(138px);
        padding: Translate(20px);
        background-size: 100% 100%;
        box-sizing: border-box;
        border-radius: Translate(8px);
        transition: all 0.3s ease-in;

        &:hover {
          transform: translateY(Translate(-2px));
          box-shadow: 0 4px 8px 0 rgba(166, 166, 166, 0.1);
        }

        .card-title {
          display: flex;
          align-items: center;
          gap: Translate(6px);
          @include Text(18px, 600, 24px, #111111, 'PingFangSC-Semibold');

          img {
            width: Translate(18px);
            height: Translate(18px);
          }
        }

        .card-desc {
          margin-top: Translate(4px);
          @include Text(14px, 400, 24px, #333333, 'PingFangSC-Regular');
        }
      }
    }
  }
}
</style>
